export default __webpack_public_path__ + "static/media/legendary-icon.3052185d.png";